import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'hasProp',
    standalone: true,
})
export class HasPropPipe implements PipeTransform
{
    transform(object: object, prop: string): boolean
    {
        return Object.hasOwn(object, prop);
    }
}

@Pipe({
    name: 'isTransient',
    standalone: true,
})
export class IsTransientPipe implements PipeTransform
{
    transform(object: object): boolean
    {
        return !Object.hasOwn(object, 'id') || !object['id'] || object['id'] === 'new';
    }
}
